import styles from "./TitlePage.module.scss";
import cn from "classnames";

import iconHappy from '~/assets/img/happy-emoji.jpg'

interface TitlePage {
  name: string;
  number: string;
  description?: string;
  classNameDescription?: string;
  isRenderIconHappy?: boolean;
}

export const TitlePage = ({ name, number, description, isRenderIconHappy = false, classNameDescription }: TitlePage) => (
  <div className={styles.container}>
    <p className={styles.number}>{number}</p>
    <div className={styles.containerTitle}>
      <h2 className={styles.name}>
        <span>{name}</span>
        {isRenderIconHappy && <img src={iconHappy} alt="" className={styles.iconHappyEmoji} />}
      </h2>
      {description && (
        <p className={cn(styles.description, classNameDescription)}>{description}</p>
      )}
    </div>
  </div>
);
